"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const locale_1 = require("../../helper/locale");
const Route_1 = __importDefault(require("../../stores/Route"));
const LANGUAGE_HEADER = 'sw-language-id';
class ShopLanguageMiddleware {
    pre(context) {
        const { url, init } = context;
        const fetchParams = { url, init };
        const headers = new Headers(fetchParams.init.headers);
        headers.delete(LANGUAGE_HEADER);
        if (Route_1.default.localeOfUrl) {
            const languageId = (0, locale_1.getLanguageIdFromLocale)(Route_1.default.localeOfUrl);
            if (null !== languageId) {
                headers.set(LANGUAGE_HEADER, languageId);
            }
        }
        fetchParams.init.headers = headers;
        return Promise.resolve(fetchParams);
    }
}
exports.default = new ShopLanguageMiddleware();
